module.exports = __webpack_public_path__ + "img/36987-004.c617f7d7.jpg";